import React from "react";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import { Tag } from "primereact/tag";
import Langs, { Localize } from "../../app/lang/langs";
import { getTagClass } from "../../app/utils/helpers";

// --- Date Formatting ---

export function formatDate(value) {
  if (value) {
    value = new Date(value);
    return value.toLocaleDateString({
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }
  return null;
}

export function dateBodyTemplate(rowData, column) {
  if (rowData[column.field]) {
    return <label>{formatDate(rowData[column.field])}</label>;
  }
}

export function startDateBodyTemplate(rowData, column) {
  if (rowData[column.field]) {
    let color = "black";
    if (moment(rowData[column.field]).isAfter(moment())) {
      color = "green";
    }
    return (
      <strong style={{ color }}>{formatDate(rowData[column.field])}</strong>
    );
  }
}

export function endDateBodyTemplate(rowData, column) {
  if (rowData[column.field]) {
    let color = "black";
    if (moment(rowData[column.field]).isBefore(moment())) {
      color = "red";
    }
    return (
      <strong style={{ color }}>{formatDate(rowData[column.field])}</strong>
    );
  }
}

export function dateFilterTemplate(options) {
  return (
    <Calendar
      value={options.value}
      onChange={(e) => options.filterCallback(e.value, options.index)}
      dateFormat="dd/mm/yy"
      placeholder="dd/mm/yyyy"
      mask="99/99/9999"
    />
  );
}

// --- Status Templates ---

export function statusBodyTemplate(rowData) {
  if (rowData.is_new) {
    return <Tag value={<Langs str="New" />} severity={getTagClass("New")} />;
  }
  return (
    <div
      style={{
        color: ["Présent", "Actif"].includes(rowData.statut)
          ? "green"
          : "red",
      }}
    >
      <strong>{rowData.statut}</strong>
    </div>
  );
}

export function statusFollowupBodyTemplate(rowData) {
  return (
    <Tag
      value={<Langs str={rowData.status} />}
      severity={getTagClass(rowData.status)}
    />
  );
}

export function typeFollowupBodyTemplate(rowData) {
  return (
    <Tag
      value={<Langs str={rowData.type} />}
      severity={getTagClass(rowData.type)}
    />
  );
}

export function typeCollabBodyTemplate(rowData) {
  return (
    <Tag
      severity={getTagClass(rowData.type_collab)}
      value={Localize(rowData.type_collab)}
    />
  );
}

export function silaeStatusBodyTemplate(silaeStatus) {
  let background = "grey";
  let color = "white";
  let border = "none";
  switch (silaeStatus) {
    case "Closed":
      background = "red";
      break;
    case "Non-Closed":
      background = "slateBlue";
      break;
    case "Ongoing":
      background = "white";
      color = "black";
      border = "1px solid black";
      break;
    default:
      break;
  }
  return (
    <Tag style={{ background, color, border }} value={Localize(silaeStatus)} />
  );
}

// --- Generic Status/Item Templates ---

export function statusItemTemplate(option) {
  if (option)
    return (
      <Tag value={<Langs str={option} />} severity={getTagClass(option)} />
    );
  return (
    <div>
      <Langs str={"Select"} />
    </div>
  );
}

export function companiesItemTemplate(option) {
  if (option)
    return (
      <div className="flex align-items-center gap-2">
        <span>{option}</span>
      </div>
    );
  return (
    <div>
      <Langs str={"Select"} />
    </div>
  );
}

// --- Row Filter Templates ---

export function createDropdownFilterTemplate(options_list, itemTemplate) {
  return function (options) {
    return (
      <Dropdown
        value={options.value}
        options={options_list}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={itemTemplate || statusItemTemplate}
        valueTemplate={itemTemplate || statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: "12rem" }}
      />
    );
  };
}

export function createMultiSelectFilterTemplate(options_list) {
  return function (options) {
    return (
      <MultiSelect
        value={options.value || []}
        options={options_list}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={<Langs str={"Select One"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: "12rem" }}
      />
    );
  };
}

// --- Filter Functions ---

export function contractTypeFilterFunction(value, filters) {
  if (!filters || filters.length === 0) return true;
  return filters.includes(value);
}

export function motifSortieFilterFunction(value, filters) {
  if (!filters || filters.length === 0) return true;
  return filters.includes(value);
}

// --- Constants ---

export const typeOfContractStrings = [
  "CDI",
  "Indépendant",
  "Portage",
  "Contrat d'apprentissage",
  "Sous traitant",
  "Intérimaire",
  "CDD",
  "Agence",
  "Convention de stage",
]

export const typesOfMotifSortie = [
  "Démission",
  "Licenciement",
  "Rupture conventionnelle",
  "Rupture anticipée du contrat",
  "Fin de CDD",
  "Fin de contrat d’apprentissage ",
  "Fin de mission",
  "Fin de stage",
  "N'a pas démarré",
  "Rupture de période d’essai employeur",
  "Rupture de période d’essai salarié",
  "Rupture décision administrative",
  "Retraite",
  "Décès",
  "Invalidité"
]

// --- Scroll Height Helper ---

export function getScrollHeight(isMobile) {
  switch (isMobile) {
    case 2:
      return "calc(100vh - 340px)";
    case 3:
      return "calc(100vh - 270px)";
    default:
      return "calc(100vh - 280px)";
  }
}
